import { ApiProvider } from "@allergy123/api-client/react";
import { authClientFromEnv, createMockAuthClient } from "@allergy123/auth-client";
import { AuthProvider } from "@allergy123/auth-client/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { router } from "./routes";
import "./styles.css";

const env = {
  AUTH_AUTHORITY: import.meta.env.VITE_AUTH_AUTHORITY as string | undefined,
  AUTH_CLIENT_ID: import.meta.env.VITE_AUTH_CLIENT_ID as string | undefined,
  AUTH_MOCK: import.meta.env.VITE_AUTH_MOCK as string | undefined,
};
const apiBaseUrl = (import.meta.env.VITE_API_URL as string | undefined) ?? "http://localhost:8787/v1";

const clientPromise =
  !env.AUTH_AUTHORITY || env.AUTH_MOCK === "1"
    ? Promise.resolve(createMockAuthClient({ user: { sub: "mock-rep", email: "rep@example.test", name: "Mock Representative", groups: ["reps"] } }))
    : authClientFromEnv(env, window.location.origin);

clientPromise.then((client) => {
  const apiConfig = { baseUrl: apiBaseUrl, token: async () => (await client.getSession())?.idToken ?? null };
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <AuthProvider client={client}>
        <ApiProvider config={apiConfig}>
          <RouterProvider router={router} />
        </ApiProvider>
      </AuthProvider>
    </StrictMode>,
  );
});
